/**
 * Trip Hub manifest.
 *
 * Adding a trip: append an entry and create a sibling folder keyed by slug
 * (e.g. `./<slug>/`) mirroring the trip's deploy directory — `index.html`
 * plus any assets (favicons, etc.). The app reads only this file at runtime;
 * the subfolder is git-versioned provenance for what's hosted at `artifactUrl`.
 */

export type Trip = {
  /** URL slug and folder name. Kebab-case, unique. */
  slug: string
  /** Display name. */
  title: string
  /** ISO date (YYYY-MM-DD) of trip start. */
  startDate: string
  /** ISO date (YYYY-MM-DD) of trip end. */
  endDate: string
  /** One-sentence tagline shown on the card. */
  tagline: string
  /** External URL where the artifact is hosted. */
  artifactUrl: string
}

export const trips: readonly Trip[] = [
  {
    slug: 'iceland-2026',
    title: 'Iceland Innovation Week',
    startDate: '2026-04-25',
    endDate: '2026-05-02',
    tagline: 'Anthos × Greylock × Loop3 — working sessions in Reykjavik.',
    artifactUrl: 'https://iceland-2026.loop3.ai',
  },
] as const
